<template>
  <div class="container">
<!--    <div class="header" v-if="integral">完成测试可获得{{integral}}金币</div>-->
    <div class="start01" v-if="currentIndex === -1">
      <div class="header" v-if="arg.indexOf('app') >= 0">
        <img @click="share" alt="" src="/static/images/share.png">
      </div>
      <div class="index_top">
        <div class="img">
          <img src="../../assets/images/testtitbg.png?v=1"/>
        </div>
        <div class="tit">
          <p><strong>糖化反应</strong>，是指肌肤新陈代谢过慢，导致多余的糖分在血液中游离，与胶原蛋白结合产生“蛋白质高度糖化终产物（AGEs）”，
            <strong>会使皮肤的胶原蛋白层被破坏，从而导致皮肤衰老、肤色暗沉等皮肤问题</strong>。</p>
          <p>20-80岁期间皮肤胶原中早期糖化产物增加33%，糖基化终末产物随年龄而明显增加（5倍）。</p>
          <p>糖化反应在体内一直发生且不可逆，对肌肤的衰老影响巨大，那么让我们来<strong style="color: red;">测一测自身的糖化度吧！</strong></p>
        </div>
<!--        <div class="list">-->
<!--          <ul>-->
<!--            <li v-for="item in dlist" :key="item">{{item}}</li>-->
<!--          </ul>-->
<!--        </div>-->
      </div>
      <div class="index_bottom">
<!--        <div class="desc">题目总共有<span>{{info.examincount}}</span>道，请如实回答，我们会给出相应的专业护理及产品搭配方案</div>-->
        <div class="btn" @click="handleStart"><img src="../../assets/images/starttest.png"/></div>
      </div>
    </div>
    <div class="start02" v-if="currentIndex > -1">
      <div class="header" v-if="arg.indexOf('app') >= 0">
        <img @click="share" alt="" src="/static/images/share.png">
      </div>
      <div class="index-top"></div>
      <div class="tban">
        <img src="../../assets/images/answerbg.png"/>
        <div class="mention">
          <div class="mentionflag"><img src="../../assets/images/testicon.png"/>第{{currentIndex >= 20 ? currentIndex : (currentIndex+1)}}题/共{{info.examincount}}题</div>
          <div class="mentiontit">
            <div style="display: inline-block;margin: 0 auto">
              <div class="CrrayNo">{{currentInfo.title.split('^')[0]}}</div>
              <div class="CrrayTit">{{currentInfo.title.split('^')[1]}}</div>
            </div>

          </div>
          <div class="mentionlist">
            <div class="item" v-for="(item,index) in currentInfo.optionlist" :key="item.key" @click="handleCrray(index)">
              <img src="../../assets/images/testbordertop.png" class="topimg"/>
              <img src="../../assets/images/testborderbottom.png" class="bottomimg"/>
              <div class="bg" :class="item.key === currentOptionKey?'active':''">
                <div class="txt">
                  {{item.value}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mentionbtnlist">
          <img src="../../assets/images/upQuestion.png" @click="handleUpPage"/>
          <img src="../../assets/images/nextQuestion.png" @click="handleNextPage" v-if="(currentIndex+1) < info.examincount"/>
          <img src="../../assets/images/testresult.png" @click="handleLastPage" v-if="(currentIndex+1) === info.examincount"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {basepath, fenxiang, isApp, isWeixin, wxAjaxData} from '../../assets/common/js/config'
  import wx from 'weixin-js-sdk'

export default {
  name: 'index',
  data () {
    return {
      info: {},
      dlist: [],
      currentInfo: {},
      currentIndex: -1,
      currentOptionKey: '',
      integral: 0,
      title: '太可怕了，不测不知道，这些导致肌肤糖化的习惯我中了10条……',
      desc: '烂脸、长皱纹、垮脸、显老，都是肌肤糖化的表现，这些变丑的习惯快停止',
      img: basepath + 'static/images/ndoshare.jpg?v=1',
      arg: isApp(),
      shareUrl: basepath + 'Wxmall/WeChat/share' + wxAjaxData
    }
  },
  mounted: function () {
    this.getData()
    this.dataCollection()
  },
  methods: {
    getData () {
      let url = this.$ajax.getexaminlist_URL, arg = isApp()
      this.$customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          this.info = res.data
          this.integral = res.data.gold
          if (isWeixin()) {
            if (arg == '') {
              fenxiang({
                title: encodeURIComponent(this.title),
                desc: encodeURIComponent(this.desc),
                imgx: this.img,
                type: 'ndo',
                path: 'ndoIndex',
                dataStr: 'type=ndo'
              })
            } else if (arg.indexOf('xcx') >= 0) {
              var xcxObj = {
                type: 'ndo',
                title: encodeURIComponent(this.title),
                link: basepath + 'ndo?1=1' + arg
              }
              wx.miniProgram.postMessage({data: xcxObj})
            }
          }
          this.dlist = res.data.skindesc.split('，')
          if (localStorage.getItem('NDO_currentIndex')) {
            this.currentIndex = parseInt(localStorage.getItem('NDO_currentIndex'))
          }
          if (this.currentIndex > -1) {
            this.currentInfo = res.data.themelist[this.currentIndex]
            this.getOptionKey()
          }
          // this.handleStart()
        }
      })
    },
    handleStart () {
      this.currentIndex = 0
      this.currentInfo = this.info.themelist[this.currentIndex]
    },
    handleCrray (index) {
      this.currentOptionKey = this.currentInfo.optionlist[index].key
    },
    handleUpPage () {
      if (this.currentIndex === 0) {
        return
      }
      if (localStorage.getItem('NDO_keylist') && this.currentOptionKey) {
        let keylist = JSON.parse(localStorage.getItem('NDO_keylist'))
        keylist[this.currentIndex] = this.currentOptionKey
        localStorage.setItem('NDO_keylist', JSON.stringify(keylist))
      }
      this.currentIndex--
      this.currentInfo = this.info.themelist[this.currentIndex]
      this.getOptionKey()
      localStorage.setItem('NDO_currentIndex', this.currentIndex)
    },
    handleNextPage () {
      if (!this.currentOptionKey) {
        this.$toast('请为当前的题目选择正确的答案')
        return
      }
      if ((this.currentIndex + 1) < this.info.examincount) {
        this.currentIndex++
        this.currentInfo = this.info.themelist[this.currentIndex]
      }
      this.setOptionKey()
    },
    handleLastPage () {
      if (!this.currentOptionKey) {
        this.$toast('请为当前的题目选择正确的答案')
        return
      }
      this.currentIndex++
      let keylist = this.setOptionKey(), resultlist = [], total = 0

      this.info.themelist.forEach(function (item, index) {
        resultlist.push({
          id: item.id,
          key: keylist[index]
        })
        total += keylist[index] == 'A' ? 2 : keylist[index] == 'B' ? 1 : 0
      })
      // console.log(total)

      let url = this.$ajax.addexamin_URL
      var data = {
        resultlist: JSON.stringify(resultlist),
        totalscore: parseInt(total)
      }
      this.$customRequestAjax.post(url, data).then(res => {
        if (res.data.code === 200) {
          localStorage.removeItem('NDO_currentIndex')
          localStorage.removeItem('NDO_keylist')
          // setCookie('ndoresult', JSON.stringify({
          //   skin_type: res.data.skin_type
          // }))
          if (this.$route.query.pt && ((this.$route.query.pt).toLowerCase() === 'app' || (this.$route.query.pt).toLowerCase() === 'xcx')) {
            // let obj = {
            //   type: 'saveresult',
            //   skin_type: res.data.skin_type && res.data.skin_type.length > 0 ? res.data.skin_type : ''
            // }
            // window.ReactNativeWebView.postMessage(JSON.stringify(obj))
            this.handleStart()
            this.$router.push({
              path: '/ndoresult',
              query: {
                totalscore: total,
                pt: this.$route.query.pt,
                token: this.$route.query.token,
                islogin: this.$route.query.islogin,
                integral: this.integral
              }
            })
          } else {
            this.$router.push({
              path: '/ndoresult',
              query: {
                totalscore: total,
                integral: this.integral
              }
            })
          }
        }
      })
    },
    getOptionKey () {
      let keylist = []
      if (localStorage.getItem('NDO_keylist')) {
        keylist = JSON.parse(localStorage.getItem('NDO_keylist'))
        this.currentOptionKey = keylist[this.currentIndex]
      }
    },
    setOptionKey () {
      let keylist = []
      if (localStorage.getItem('NDO_keylist')) {
        keylist = JSON.parse(localStorage.getItem('NDO_keylist'))
        if (keylist[this.currentIndex - 1]) {
          keylist[this.currentIndex - 1] = this.currentOptionKey
          this.currentOptionKey = keylist[this.currentIndex]
        } else {
          keylist.push(this.currentOptionKey)
          this.currentOptionKey = ''
        }
        localStorage.setItem('NDO_keylist', JSON.stringify(keylist))
      } else {
        keylist.push(this.currentOptionKey)
        localStorage.setItem('NDO_keylist', JSON.stringify(keylist))
        this.currentOptionKey = ''
      }
      if (this.currentIndex < this.info.examincount) {
        localStorage.setItem('NDO_currentIndex', this.currentIndex)
      } else {
        localStorage.removeItem('NDO_currentIndex')
      }
      return keylist
    },
    // 埋点-皮肤测试
    dataCollection () {
      let params = {
        'flowArea_var': '皮肤测试', // 区域
        'position_var': 1, // 坑位
        'flowName_var': '皮肤测试', // 流量位名称
        'productName_var': '', // 商品名称
      }
      gio('track', 'flowLocationClick', params)
    },
    share () {
      var obj = {
        type: 'shareFriends',
        title: encodeURIComponent(this.title),
        img: this.img,
        desc: encodeURIComponent(this.desc),
        link: encodeURIComponent(this.shareUrl + '&type=ndo')
      }
      window.ReactNativeWebView.postMessage(JSON.stringify(obj))
    }
  }
}
</script>

<style scoped lang="scss">
  .container {
    background: #FECFBD;
    .header {
      margin: 0.1rem;
      text-align: center;
      /*color: #FC0324;*/
      font-size: 0.12rem;
      /*background: #FDDADC;*/
      border-radius: 0.04rem;
      line-height: 0.32rem;
      position: relative;
      z-index: 10;
      display: flex;
      justify-content: flex-end;
      img {
        width: 0.2rem;
        height: 0.2rem;
      }
    }
    .start01{
      .index_top {
        background: #FFE4CC;
        padding: .25rem .18rem;
        padding-top: .28rem;
        padding-left: .33rem;
        overflow: hidden;
        .img {
          width: 2.89rem;
          height: 1.02rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .tit {
          margin-top: .2rem;
          font-size: .16rem;
          color: #727272;
          line-height: .25rem;
          text-align: left;
          /*padding-left: .09rem;*/
          p {
            margin-top: 0.1rem;
          }
        }
        .list {
          margin-top: .2rem;
          padding-left: .2rem;
          margin-left: .09rem;
          ul {
            li {
              float: left;
              width: 33.3%;
              font-size: .16rem;
              line-height: .38rem;
              color: #4F4F4F;
              list-style: disc;
            }
          }
        }

      }
      .index_bottom {
        padding-left: .48rem;
        padding-right: .48rem;
        padding-bottom: .15rem;
        border-top:solid 1px #2E2E2E;
        .desc {
          margin-top: .21rem;
          font-size: .16rem;
          color: #727272;
          line-height: .2rem;
          span{
            background:rgba(233,239,253,0.28);
            border-radius:.1rem;
            padding: 0 .1rem;
            font-size: .2rem;
            color:#5D5D5D;
            font-weight: 700;
          }
        }
        .btn {
          width: 1.7rem;
          margin:0 auto;
          margin-top: .24rem;
          img{
            width: 100%;
          }
        }
      }
    }
    .start02{
      position: absolute;
      min-height: 100%;
      left:0;
      top:0;
      background: #FECFBD;
      width: 100%;
      .index-top{
        background: #FFE4CC;
        height: 60%;
        position: absolute;
        top:0;
        left:0;
        z-index: 0;
        width: 100%;
      }
      .tban{
        position: relative;
        padding-top: .17rem;
        padding-left: .12rem;
        padding-right: .14rem;
        img{
          width: 100%;
        }
        .mention{
          position: absolute;
          top:.41rem;
          left:0;
          width: 100%;
          padding-left: .34rem;
          padding-right: .33rem;
          .mentionflag{
            text-align: center;
            font-size: .13rem;
            color:#8E8E8D;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
              width: .11rem;
              height: .06rem;
              vertical-align: middle;
              display: inline-block;
            }
          }
          .mentiontit{
            font-size: .22rem;
            color:#444444;
            line-height: .3rem;
            margin-top:.15rem;
            min-height: .6rem;
            font-weight:700;
            /*display: flex;*/
            /*justify-content: center;*/
            text-align: center;
            overflow: hidden;
            .CrrayNo{
              background: url('../../assets/images/testCarryNo.png') center no-repeat;
              background-size: .28rem .29rem;
              width: .3rem;
              height: .29rem;
              font-size: .18rem;
              line-height: .29rem;
              text-align: center;
              float: left;
            }
            .CrrayTit{
              float: left;
              max-width: 90%;
              padding-left: .1rem;
              text-align: left;
            }
          }
          .mentionlist{
            max-height:3.55rem;
            overflow-y: auto;
            overflow-x: hidden;
            .item{
              margin-top: .21rem;
              background: url('../../assets/images/testborderline.png') center repeat-y;
              background-size: 100%;
              position: relative;
              min-height: .63rem;
              padding-top: .05rem;
              padding-left: .12rem;
              padding-right: .1rem;
              padding-bottom: .1rem;
              .topimg{
                width: 100%;
                position: absolute;
                top:0;
                left:0;
              }
              .bottomimg{
                position: absolute;
                bottom: 0;
                left:0;
                width: 100%;
              }
              .bg{
                width: 100%;
                background: url('../../assets/images/testborderselectbg.png') center repeat-y;
                background-size: 100%;
                z-index: 0;
                padding: .15rem .19rem;
                padding-bottom: .12rem;
                font-size: 0;
                text-align: center;
              }
              .bg.active{
                background: url('../../assets/images/testborderselected.png') center repeat-y;
                background-size: 100%;
                text-align: center;
              }
              .txt{
                font-size: .14rem;
                line-height: .2rem;
                display: inline-block;
                text-align: left;
              }
            }
          }
        }
        .mentionbtnlist{
          position: absolute;
          bottom: .23rem;
          left:10%;
          width: 80%;
          padding: .1rem .2rem;
          img{
            width: 1.1rem;
            height: .42rem;
          }
          img:nth-child(1){
            float: left;
          }
          img:nth-child(2){
            float: right;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ndo/index.vue